/**
 * @author       luis.orihuela@agileengine.com (Luis Orihuela)
 * @copyright    Copyright (c) 2020, Zumper
 */

import type { TopListable } from '@zcode/bizos'
import { EVENT_NAMES, PROP_NAMES, track } from '@zcode/mixpanel'
import type {
  Dispatch,
  GetState,
  Listable,
  Pin,
  Property,
  RawPinInventorySearch,
} from '@zcode/state-type'
import type { PageName } from '../helpers'
import { getCommonProps } from '../helpers/getCommonProps'

export const mixpanelMaplistClick =
  ({
    buttonClicked,
    entity,
    pageName,
    section,
  }: {
    buttonClicked?: string
    entity?: Listable | Pin<RawPinInventorySearch> | Property | TopListable | null
    pageName?: PageName
    section?: string
  }) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const payload: { [key: string]: any } = {
      ...(section && { [PROP_NAMES.SECTION]: section }),
      [PROP_NAMES.BUTTON_CLICKED]: buttonClicked,
      ...getCommonProps({ state, pageName, entity }),
    }

    track({
      event: EVENT_NAMES.CLICK,
      payload,
    })
  }
